import React from 'react';
import '../../styles/WhyChooseBetaque.css';

interface WhyChooseBetaqueProps {
  industryName: string;
  description: string;
  benefits: string[];
}

const WhyChooseBetaque: React.FC<WhyChooseBetaqueProps> = ({ industryName, description, benefits }) => {
  return (
    <section className="why-choose-section">
      <div className="glass-overlay"></div>
      <div className="why-choose-container">
        <div className="why-choose-header">
          <h2 className="why-choose-title">
            Why Choose Betaque for <br/><span className="highlight">{industryName}</span>
          </h2>
          <p className="why-choose-description">{description}</p>
        </div>
        
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <div className="benefit-item" key={index}>
              <div className="benefit-number">{(index + 1).toString().padStart(2, '0')}</div>
              <div className="benefit-content">
                <p>{benefit}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="geometric-shape shape-1"></div>
      <div className="geometric-shape shape-2"></div>
      <div className="geometric-shape shape-3"></div>
      <div className="geometric-shape shape-4"></div>
    </section>
  );
};

export default WhyChooseBetaque; 